import React from 'react';

import img4 from './../../../assets/img/projects/marmalade/hero.jpg';


class Hero extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <section className="section">
                <div className="mole__hero">
                    <figure>
                        <img src={img4} alt="Static Project Layout" title="Static Project Layout"/>
                        <figcaption>
                            <div className="main-container">
                                <h2 className="font-lg-head c-general">Static Project Layout</h2>
                            </div>
                        </figcaption>
                    </figure>
                </div>
            </section>
        );
    }
}
export default Hero;



// WEBPACK FOOTER //
// ./src/components/Projects/Details/Hero.js